import './style/style.scss';
// import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './home';
import Notification from './components/notification';
import Introduction from './components/introduction';
import DirectPages from './components/notification/directpages';
import UnderConstruction from './components/notification/underconstruction';
function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/introduction" element={<Introduction />} />
          <Route path="/editor" element={<Home />} />
          <Route path="/notification" element={<Notification />} />
          <Route path="/underconstruction" element={<UnderConstruction />} />
          <Route path="*" element={<DirectPages />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
